<div
  class="flex flex-col gap-1 p-3 h-full bg-white border border-e-support-10 rounded-2xl shadow-sm hover:shadow-md hover:border-hovergray transition-all">
  <span class="text-[11px] font-extrabold text-slate-500 tracking-wider">
    {{ label }}
  </span>

  <span class="text-xl font-extrabold text-mdPrimary-500">
    {{ value }}
  </span>

  <div class="flex items-center gap-2 min-h-[18px]">
    @if (delta) {
    <span class="text-[11px] font-bold inline-flex items-center gap-0.5"
      [ngClass]="trend === 'down' ? 'text-danger' : 'text-e-support-5'">
      <span class="text-[16px] leading-none">
        {{ trend === 'down' ? '▼' : '▲' }}
      </span>
      {{ delta }}
    </span>
    }
    @if (note) {
    <span class="text-[10px] font-bold text-slate-400">{{ note }}</span>
    }
  </div>

  <div class="w-full h-1 bg-slate-200 rounded-full overflow-hidden mt-1.5">
    <div class="h-full rounded-full transition-all duration-500" [style.width.%]="barWidth"
      [style.background-color]="resolvedBarColor"></div>
  </div>

  @if (footnote) {
  <span class="text-[10px] font-bold text-slate-400">{{ footnote }}</span>
  }
</div>